export default "__VITE_ASSET__C0xn1c5A__"